<div class="rss-feed-container">
  <h2 i18n="rss feed header@@rss-feed-header" class="widget-header h4 d-none  d-lg-block">RSS feed</h2>

  <div *ngIf="subscribedToRssFeature">
    <div *ngIf="isFeedUrlConfigured; else noFeeds" class="mt-2">
      <div *ngIf="feeds$ | async as feeds; else loading" class="feed-wrapper">
        <ul class="row list-unstyled">
          <li *ngFor="let feedItem of feedsToShow">
            <div class="site-container">
              <div class="feed-title compact-feed-content">
                <h4 class="h6 mb-0">
                  <a href="{{feedItem.Url}}" class="card-title mb-0 feed-clickable-link"><span
                      class="extra-bold">{{feedItem.Title}}</span></a>
                </h4>
              </div>
              <span class="small">{{feedItem.PublishedDate| date}} | </span><span
                class="small">{{feedItem.TagName}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div *ngIf="fetchedAmountOfFeeds > 4" class="row justify-content-start">
    <div class="col-auto pr-0 pl-0">
      <button mat-button class="events-show-more-btn" (click)="clickShowPrevious()"
        [disabled]="numberOfShowMoreClicks === 0">
        <span class="small bolder" i18n="@@show-previous">Previous</span>
      </button>
    </div>
    <div class="pt-2">
      <span class="dot mr-1" [ngClass]="numberOfShowMoreClicks === 0 ? 'accent-2-bg-color' : 'dot-bg-color'"></span>
      <span *ngIf="fetchedAmountOfFeeds > 4" class="dot mr-1" [ngClass]="numberOfShowMoreClicks === 1 ? 'accent-2-bg-color' : 'dot-bg-color'"></span>
      <span *ngIf="fetchedAmountOfFeeds > 8" class="dot"
        [ngClass]="numberOfShowMoreClicks === 2 ? 'accent-2-bg-color' : 'dot-bg-color'"></span>
    </div>
    <div class="col-auto pr-0 pl-0">
      <button mat-button class="events-show-more-btn" (click)="clickShowNext()"
        [disabled]="numberOfShowMoreClicks === 2 || numberOfShowMoreClicks === maxNumberOfShowMoreClicks">
        <span class="small bolder" i18n="@@show-next">Next</span>
      </button>
    </div>
  </div>
</div>
  
  
  <ng-template #loading>
    <div *ngIf="errorSubject$ | async as err; else innerLoading">
      <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
    </div>
    <ng-template #innerLoading>
      <div>
        <app-widget-placeholder></app-widget-placeholder>
      </div>
    </ng-template>
  </ng-template>

  <ng-template #noFeeds>
    <div>
      <app-text-placeholder>
        <p i18n="no feeds@@no-feeds">Please configure the feed source URI.</p>
      </app-text-placeholder>
    </div>
  </ng-template>
